import { getFasitProblemDetails } from '../../../api-service';

// Forum's 400s carry a caseworker-facing reason; other failures keep the caller's own message.
export function forumRejectionReason(error: unknown): string | undefined {
  const problemDetails = getFasitProblemDetails(error);
  return problemDetails?.status === 400 ? problemDetails.title : undefined;
}
